import { type MouseEvent, type FC, type KeyboardEvent, type ReactNode } from 'react';
import classnames from 'classnames';
import styles from './main.scss';

type DropdownOptionProps = {
    children: ReactNode;
    dataTn?: string;
    id?: string;
    isHighlighted?: boolean;
    isSelected?: boolean;
    isDisabled?: boolean;
    onClick?: (e: MouseEvent) => void;
    onKeyDown?: (e: KeyboardEvent) => void;
    onMouseDown?: () => void;
    onMouseMove?: () => void;
};

export const DropdownOption: FC<DropdownOptionProps> = ({
    children,
    dataTn,
    id,
    isHighlighted,
    isSelected,
    isDisabled,
    onClick,
    onKeyDown,
    onMouseDown,
    onMouseMove,
}) => {
    const className = classnames(styles.option, {
        [styles.optionSelected]: isSelected && !isDisabled,
        [styles.optionDisabled]: isDisabled,
    });

    const eventProps = isDisabled
        ? {}
        : {
              onClick: (e: MouseEvent) => {
                  e.preventDefault();
                  if (onClick) {
                      onClick(e);
                  }
              },
              onKeyDown: (e: KeyboardEvent) => {
                  e.preventDefault();
                  if (onKeyDown) {
                      onKeyDown(e);
                  }
              },
              onMouseDown,
              onMouseMove,
          };

    return (
        <>
            {/* a11y handled by downshift */}
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div className={className} data-tn={dataTn} id={id} {...eventProps}>
                <div
                    className={classnames(styles.optionBackdrop, {
                        [styles.optionHighlight]: isHighlighted,
                    })}
                />
                {children}
            </div>
        </>
    );
};
